<template lang="pug">
  v-container(fluid)
    v-row.primary.lighten-2(justify="center")
      v-col(cols="12")
        .display-2.text-center.white--text.py-3(height="56" ) Meet Our Family
    v-row(justify="center")
      v-col(cols="12")
        v-card.success.darken-2(dark)
          v-container(fluid )
            .display-1.text-center The Shepherd's Table - Pastoral Team
            v-row(justify="center")
              v-col(cols="12" sm="6" md="3" align="center")
                v-img(width="auto" max-width="300px"   src="../../assets/img/people/AnnJefferson.png" )
                .headline Pastor Ann Jefferson
                .title Worship & Liturgy Pastor
                .subtitle Worship Arts & Music
                Email(email="#")
              v-col(cols="12" sm="6" md="3" align="center")
                v-img(width="auto" max-width="300px"   src="../../assets/img/people/ToniDunbar.png" )
                .headline Pastor Toni Dunbar
                .title Education Pastor
                .subtitle YA Flunder Foundation
                .subtitle Refuge Leadership Development Institute
                Email(email="#")
              v-col(cols="12" sm="6" md="3" align="center")
                v-img(width="auto" max-width="300px"   src="../../assets/img/people/TerrieChan.png" )
                .headline Pastor Terrie Chan
                .title Board of Ministries Pastor
                .subtitle Pathways Women's Ministry Outreach
                .subtitle
                Email(email="#")
              v-col(cols="12" sm="6" md="3" align="center")
                v-img(width="auto" max-width="300px"   src="../../assets/img/people/PaulCroeger.png" )
                .headline Pastor Paul Croeger
                .title Board of Ministries Pastor
                .subtitle Health
                .subtitle Transgender Ministry
                Email(email="#")
            v-row(justify="center")
              v-col(cols="12" sm="6" md="3" align="center")
                v-img(width="auto" max-width="300px"   src="../../assets/img/people/PhilGray.png" )
                .headline Pastor Pastor Phil Gray
                .title Counseling Pastor
                Email(email="#")
              v-col(cols="12" sm="6" md="3" align="center")
                v-img(width="auto" max-width="300px"   src="../../assets/img/people/ErnestLarkins.png" )
                .headline Pastor Ernest Larkins
                .title Youth &
                .title Young Adult Pastor
                Email(email="#")
              v-col(cols="12" sm="6" md="3" align="center")
                v-img(width="auto" max-width="300px"   src="../../assets/img/people/JaniceSommerville.png" )
                .headline Pastor Janice Sommerville
                .title Administrative Pastor
                .subtitle Members Services
                .subtitle Mental Health/First Aid
                .subtitle Transgender Ministry
                Email(email="#")
              v-col(cols="12" sm="6" md="3" align="center")
                v-img(width="auto" max-width="300px"   src="../../assets/img/people/AnnAmeling.png" )
                .headline Pastor Ann Ameling
                .title Pastor Emeritus
                .subtitle SF Satellite Ministry
                .subtitle Transgender Ministry
                Email(email="#")
    v-row(justify="center")
      v-col(cols="12")
        v-card.info.darken-2(dark)
          v-container(fluid )
            .display-1.text-center Our Administrative Staff
            v-row(justify="center")
              v-col(cols="12" sm="6" align="center")
                v-img(width="auto" max-width="300px"   src="../../assets/img/people/SylviaRhue.png" )
                .headline Dr. Sylvia Rhue
                .title Executive Assistant to the Bishop
                .subtitle
                .subtitle Phone: (510) 633-6316 ext. 104
                Email(email="#")
              v-col(cols="12" sm="6" align="center")
                v-img(width="auto" max-width="300px"   src="../../assets/img/people/LouisKnox.png" )
                .headline Deacon Louis Knox
                .title Facilities Manager
                .subtitle
                .subtitle Phone: (510) 633-6316 ext. 105
                Email(email="#")
    v-row(justify="center")
      v-col(cols="12")
        v-card.accent.darken-2(dark)
          v-container(fluid )
            .display-1.text-center Our Deacon Board
            v-row(justify="center")
              v-col(cols="12" align="center")
                v-img(width="auto" max-width="50%"   src="../../assets/img/people/DeaconBoard.jpg" )
                v-row(justify="center")
                  v-col(cols="12" md="4" sm="6")
                    .headline Deacon Cynthia Billups
                    .title
                    .subtitle
                    .subtitle
                    Email(email="#")
                  v-col(cols="12" md="4" sm="6")
                    .headline Deacon Gamage Carter
                    .title
                    .subtitle
                    .subtitle
                    Email(email="#")
                  v-col(cols="12" md="4" sm="6")
                    .headline Deacon Pam Mack
                    .title
                    .subtitle
                    .subtitle
                    Email(email="#")
                v-row(justify="center")
                  v-col(cols="12" md="4" sm="6")
                    .headline Deacon Charles "Skip" Jones
                    .title
                    .subtitle
                    .subtitle
                    Email(email="#")
                  v-col(cols="12" md="4" sm="6")
                    .headline Deacon Gail Randall
                    .title
                    .subtitle
                    .subtitle
                    Email(email="#")
                  v-col(cols="12" md="4" sm="6")
                    .headline Deacon "Sugar Bear" Taylor
                    .title
                    .subtitle
                    .subtitle
                    Email(email="#")
    v-row(justify="center")
      v-col(cols="12")
        v-card.info.lighten-4(  )
          v-container(fluid )
            
            v-row()
              v-col(cols="12" sm="9" offset-sm="3" align="start")
                  .display-1 Contact Information
                  .headline City of Refuge UCC - 
                    span.text-no-wrap (510) 633-6316
                  .title-1.font-weight-bold Department Voicemail Extensions:
                  .body-1 ext. 104 Assistant to Bishop Flunder
                  .body-1 ext. 105 Facilities Manager
                  .body-1 ext. 110 YA Flunder Foundation
                  .body-1 ext. 111 TFAM (The Fellowship of Affirming Ministries)
                  .body-1 ext. 112 Fellowship Institute of Theology
                  .body-1 ext. 113 Green Justice (Hospitality & Food Pantry)
                  .body-1 ext. 114 Worship & Liturgy
                  .body-1 ext. 115 Music
                  .body-1 ext. 116 Youth & Young Adults
</template>

<script>
import Email from '../../components/contact/email';
export default {
  components: {
    Email
  }
};
</script>

<style lang="stylus" scoped></style>
